module.exports = __webpack_public_path__ + "img/imagen2.ed1008eb.png";